import { FC, useState } from "react"
import { useTranslation } from "react-i18next";
import modalStyles from '../../../../components/modalWindows/styles/BaseModalWindow.module.scss';
import styles from './../styles/NewsMaker.module.scss'
import BaseCreator from "../../../../components/creators/baseCreator";
import GridSelectorInput from "../../../../components/controls/GridSelectorInput";
import { IEntitySimpleDTO } from "../../../../libs/coreapi-dto/@types/common";
import UserLocalSelectorModal from "../../UserLocal/components/selectorModal/UserLocalSelectorModal";

interface INewsToUserProps {
    save: (idUserGlobal: string) => void;
    cancel: () => void;
}

const NewsToUserModal: FC<INewsToUserProps> = (props) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [user, setUser] = useState<IEntitySimpleDTO>();
    const [error, setError] = useState<string>('');
    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.newsMaker.' + value);
    const errorsT = (value: string) => t('errors.' + value);

    const handleSubmit = () => {
        if (!user?.idGlobal) {
            setError(errorsT("required"));
            return;
        }
        
        setIsSubmitting(true);
        try {
            props.save(user.idGlobal);
        } catch (error) {
            console.error(error);
            setError(errorsT("saveError"));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <BaseCreator
            isSubmitting={isSubmitting}
            save={handleSubmit}
            modalWindowClassName={modalStyles.flexModalWindow}
            cancel={props.cancel}
            valid={!!user?.idGlobal}
        >
            <div className={styles.modalContentWindow}>
                <GridSelectorInput
                    required
                    id='idUserGlobal'
                    selectedEntity={user}
                    onSelect={(e) => {
                        setUser(e);
                        setError('');
                    }}
                    selectorModalJsx={UserLocalSelectorModal}
                    error={error}
                    onFocus={() => setError('')}
                    label={baseT('idUserGlobal')}
                />
            </div>
        </BaseCreator>
    )
}

export default NewsToUserModal;